import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const useLanguage = () => {
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

  // Listen for language changes and update state
  useEffect(() => {
    setCurrentLanguage(i18n.language);
    
    // Save language preference to localStorage
    localStorage.setItem('language', i18n.language);
  }, [i18n.language]);

  // Function to change language
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return {
    currentLanguage,
    changeLanguage,
    isRTL: i18n.dir() === 'rtl',
  };
}; 